const state = {
    containerInformationFields: [
        {
            key: "pkg_code",
            label: "包裝單號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "customer_name",
            label: "客戶名稱",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pallet_weight",
            label: "總棧板重",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pallet_qty",
            label: "總棧板數",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    containerInformationItem: [
        // {
        //     pkg_code: 'BEFT1790001',
        //     customer_name: "Befestigungselemente Technik  Gmbh",
        //     address: 'Max-Planck-Str.1  54439  Saarburg Germany',
        //     pallet_qty: 10,
        // },
    ],
}
const getters = {
    get_containerInformationFields: state => {
        return state.containerInformationFields
    },
    get_containerInformationItem: state => {
        return state.containerInformationItem
    },
}
const actions = {
    set_containerInformationFields(context, array) {
        context.commit('SET_CONTAINERINFORMATIONFIELDS', array);
    },
    set_containerInformationItem(context, array) {
        context.commit('SET_CONTAINERINFORMATIONITEM', array);
    },
    clear_containerInformationItem(context) {
        context.commit('CLEAR_CONTAINERINFORMATIONITEM');
    },
}
const mutations = {
    SET_CONTAINERINFORMATIONFIELDS(state, array) {
        state.containerInformationFields = array;
    },
    SET_CONTAINERINFORMATIONITEM(state, array) {
        state.containerInformationItem = array;
    },
    CLEAR_CONTAINERINFORMATIONITEM(state) {
        state.containerInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/containerInformation.js